import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#4B0000",        // Updated primary color
      tint_1: "#651111",      // Slightly lighter
      tint_2: "#7D2222",
      tint_3: "#963333",
      tint_4_bg: "#B36666",   // Light background tint
      tint_5_bg: "#D9B3B3",   // Very light background
    },

    secondary: {
      main: "#000000",
      tint_1: "#333333",
      tint_2: "#666666",
      tint_3: "#999999",
      tint_4: "#CCCCCC",
      tint_5_bg: "#E6E6E6",
      input_field: "#FAFAFA",
    },
    error: {
      main: "#FF3B30",
    },
    // You can define other colors like warning, info, success if needed
  },
  typography: {
    fontFamily: ["Mulish"],
    allVariants: {
      color: "#666666",
    },
    button: {
      textTransform: "none",
    },
  },
});

export default theme;
